import React, {useEffect, useState} from 'react'
import {usePresupuesto, useProyecto} from "../../Profile.jsx";
import {useEditor} from "../../../../App.jsx";
import axios from "axios";
import {IconEdit, IconPlus, IconProject, IconUser} from "../../../Customiz3r/components/ToolSelectorTop/Icons.jsx";
import {EyeIcon} from "@heroicons/react/20/solid/index.js";
import "../../Profile.css"
import PresupuestoCard from "./PresupuestoCard.jsx";
import classNames from "classnames";
import Cookies from "js-cookie";
import {BriefcaseBusiness} from "lucide-react";
import {mdiArrowLeft} from "@mdi/js";
import DraggableBackButton from "../../components/Editor/DraggableBackButton.jsx";

const VerMiProyecto = () => {


    const initialState = {
        "mode": "list",
        "data": { "columns": 3 }
    };
    // Estado para el modo de vista de la lista
    const [viewMode, setViewMode] = useState(() => {
        const savedViewMode = Cookies.get('viewModeMiProyecto');
        return savedViewMode ? JSON.parse(savedViewMode) : initialState;
    });
    // Effect to update the cookie whenever viewMode changes
    useEffect(() => {
        Cookies.set('viewModeMiProyecto', JSON.stringify(viewMode), { expires: 7 }); // Save for 7 days
    }, [viewMode]);


    const {proyecto, setProyecto} = useProyecto();
    const {presupuesto, setPresupuesto} = usePresupuesto();
    const {stateEditor, setStateEditor} = useEditor();

    useEffect(() => {
        if (stateEditor?.editorID) {
            // Cargar los datos del proyecto
            axios.get(`/proyectos/${stateEditor?.editorID}/`)
                .then(response => {
                    setProyecto(response.data);
                })
                .catch(error => {
                    console.error('Error al cargar el proyecto:', error);
                });
        }
        console.log("ProyectoViewer", stateEditor?.editorID);
    }, [stateEditor?.editorID]);

    const handleEdit = () => {
        setStateEditor({
            ...stateEditor,
            editor: true,
            editorID: stateEditor?.editorID,
            editorType: "proyecto_editor"
        })

    };

    const handleEditPresupuesto = (id) =>{
        setStateEditor({
            ...stateEditor,
            editor: true,
            editorID: id,
            editorType: "presupuesto_editor"
        })
    }
    const handleVerPresupuesto = (id) =>{
        setStateEditor({
            ...stateEditor,
            editor: true,
            editorID: id,
            editorType: "mi_presupuesto_viewer"
        })
        setPresupuesto(proyecto.presupuestos.filter(presupuesto => presupuesto.id === id)[0]);
    }

    const addPresupuesto = () => {
        setStateEditor({
            ...stateEditor,
            editor: true,
            editorID: "add",
            editorType: "presupuesto_editor"
        });
    }
    return (
        <div className="flex h-full w-full items-center justify-center ">

            <div className="grid h-full w-full gap-2  grid-cols-3 grid-rows-12 rounded-lg ">

                <div
                    className="col-span-3 row-span-1 glassCard rounded-lg shadow-md flex items-center p-3 "
                >
                    <h2 className="text-3xl">Proyecto</h2>
                    <div className='w-full h-full'>

                        <div className="absolute top-0 right-0 flex">
                            {/*<button
                                className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-50 transition duration-200 ease-in-out"
                                onClick={() => {
                                    setStateEditor({
                                        ...stateEditor,
                                        editor: false,
                                        misproyectosindex: 3
                                    });

                                }}
                                aria-label="Go back"
                            >
                                <div className="flex items-center">
                                    <IconProject className="w-5 h-5" />
                                    <BriefcaseBusiness className="w-5 h-5 mr-3" />

                                    <span className="ml-2">Mis Proyectos</span>
                                </div>


                            </button>*/}

                            <DraggableBackButton
                                initialPosition={{ x: 0, y: "15px" }} // Posición inicial opcional
                                onClick={() => {
                                    setStateEditor({
                                        ...stateEditor,
                                        editor: false,
                                        misproyectosindex: 3
                                    });
                                }} // Función al hacer clic
                                iconPath={mdiArrowLeft} // Ícono opcional
                                label="Proyectos" // Texto del botón opcional
                            />
                        </div>
                    </div>

                </div>

                <div
                    className="col-span-3 row-span-2 glassCard rounded-lg shadow-md flex flex-col items-center  p-3 "
                >

                    <div className=" w-full">
                        <h2 className="text-lg font-bold w-full">Detalles de mi proyecto</h2>
                    </div>
                    <div className="flex-row h-full w-full overflow-y-auto scrollbar_mod">
                        <p><strong>Nombre:</strong> {proyecto?.nombre}</p>
                        <p><strong>Descripción:</strong> {proyecto?.descripcion}</p>
                        <p><strong>Estado:</strong> {proyecto?.estado}</p>
                        <p><strong>Fecha de Inicio:</strong> {proyecto?.fecha_inicio}</p>
                        <p><strong>Fecha de Fin:</strong> {proyecto?.fecha_fin || 'No especificada'}</p>
                    </div>
                </div>

                <div
                    className="col-span-3 row-span-9 glassCard  rounded-lg shadow-md flex items-center p-1 pt-2 "
                >
                    <div className="w-full  h-full overflow-y-auto scrollbar_mod pr-2">
                        <div className={
                            classNames(
                                'h-full m-2 mt-0 mr-0 pr-3  ',
                                viewMode.mode === 'grid' ? `grid grid-cols-${viewMode.data.columns} gap-4` : 'flex flex-col space-y-4'
                            )
                        }>
                            {proyecto?.presupuestos?.length > 0 ? (
                                proyecto?.presupuestos?.map((presupuesto, index) => (
                                    <PresupuestoCard
                                        key={presupuesto.id}
                                        presupuesto={presupuesto}
                                        handleVerPresupuesto={handleVerPresupuesto}
                                    />
                                ))
                            ) : (
                                <div className="text-center p-4 text-gray-300">
                                    No hay presupuestos para este proyecto.
                                </div>
                            )}
                        </div>

                        {/*{proyecto?.presupuestos?.length > 0 ? (
                            <table className="min-w-full w-full bg-white rounded-lg shadow-md dark:bg-gray-800 dark:border-gray-700 rounded-tl-lg rounded-tr-lg">
                                <thead className="rounded-t-lg sticky top-0 z-10">
                                <tr className="bg-gray-100 dark:bg-gray-700">
                                    <th className="py-3 px-4 border-b text-left dark:text-gray-300 rounded-tl-lg">#</th>
                                    <th className="py-3 px-4 border-b text-left dark:text-gray-300">Desc</th>
                                    <th className="py-3 px-4 border-b text-left dark:text-gray-300">Fecha de Creación</th>
                                    <th className="py-3 px-4 border-b text-left dark:text-gray-300">Aprobado</th>
                                    <th className="py-3 px-4 border-b text-left dark:text-gray-300 rounded-tr-lg">Acciones</th>
                                </tr>
                                </thead>
                                <tbody className="overflow-y-auto scrollbar_mod pr-2">
                                {proyecto?.presupuestos?.map((presupuesto, index) => (
                                    <tr
                                        key={presupuesto.id}
                                        className="hover:bg-gray-50 dark:hover:bg-gray-600 transition duration-150 ease-in-out"
                                    >
                                        <td className="py-2 px-4">{presupuesto.id}</td>
                                        <td className="py-2 px-4 dark:text-gray-300">{presupuesto.descripcion}</td>
                                        <td className="py-2 px-4 dark:text-gray-300">{presupuesto.fecha_creacion}</td>
                                        <td className="py-2 px-4 dark:text-gray-300">
                                            {presupuesto.aprobado ? 'Sí' : 'No'}
                                        </td>
                                        <td className="py-2 px-4">
                                            <button
                                                className="bg-green-500 text-white py-1 px-3 rounded-md hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-green-400 focus:ring-opacity-50 dark:bg-green-600 dark:hover:bg-green-700"
                                                onClick={() => handleVerPresupuesto(presupuesto.id)}
                                            >
                                                <EyeIcon className="w-5 h-5" />
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        ) : (
                            <div className="text-center p-4 text-gray-300">
                                No hay presupuestos para este proyecto.
                            </div>
                        )}*/}
                    </div>
                </div>

            </div>
        </div>
    );
}
export default VerMiProyecto
